function authHasPerm(userInfo, perm) {
  const [module_name, perm_name] = perm.split(".")
  if (userInfo?.permissions && userInfo.permissions[module_name]) {
    if (userInfo.permissions[module_name]["*"])
      return true
    else if (userInfo.permissions[module_name][perm_name])
      return true
  }

  return false
}

export default authHasPerm